class FacetFiltersForm extends HTMLElement {
  static subcategoryFilterParamName = 'filter.p.m.custom.filters_subcategories';
  static allSubcategoryLabels = new Set(['wszystkie', 'wszystkie produkty']);

  static isAllSubcategoryLabel(label) {
    if (!label) return false;
    return FacetFiltersForm.allSubcategoryLabels.has(label.toString().trim().toLowerCase());
  }

  static isAllSubcategoryCheckbox(checkbox) {
    if (!checkbox || checkbox.name !== FacetFiltersForm.subcategoryFilterParamName) return false;
    return FacetFiltersForm.isAllSubcategoryLabel(checkbox.getAttribute('data-label'));
  }
  constructor() {
    super(),
      (this.onActiveFilterClick = this.onActiveFilterClick.bind(this)),
      (this.debouncedOnSubmit = debounce((e) => {
        this.onSubmitHandler(e);
      }, 300)),
      this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
    const e = this.querySelector('#FacetsWrapperDesktop');
    e && e.addEventListener('keyup', onKeyUpEscape);
  }
  static setListeners() {
    window.addEventListener('popstate', (e) => {
      const t = e.state ? e.state.searchParams : FacetFiltersForm.searchParamsInitial;
      t !== FacetFiltersForm.searchParamsPrev && FacetFiltersForm.renderPage(t, null, !1);
    });
  }
  static toggleActiveFacets(e = !0) {
    document.querySelectorAll('.js-facet-remove').forEach((t) => {
      t.classList.toggle('disabled', e);
    });
  }
  static renderPage(e, t, r = !0) {
    const params = new URLSearchParams(e);
    if (r) {
      params.delete('page');
      // Keep sort/market/preview context; filters themselves come from the form.
      new URLSearchParams(window.location.search).forEach((value, key) => {
        if (!key.startsWith('filter.') && !['page', 'section_id'].includes(key) && !params.has(key)) params.append(key, value);
      });
    }
    e = params.toString();
    FacetFiltersForm.searchParamsPrev = e;
    FacetFiltersForm.requestVersion = (FacetFiltersForm.requestVersion || 0) + 1;
    const version = FacetFiltersForm.requestVersion;
    FacetFiltersForm.controller?.abort();
    FacetFiltersForm.controller = new AbortController();
    const container = document.getElementById('ProductGridContainer');
    if (container) {
      container.dataset.collectionRender = r ? 'filter' : 'history';
      document.dispatchEvent(new CustomEvent('collection:before-render', { detail: { container } }));
      container.querySelector('.collection')?.classList.add('loading');
    }
    document.getElementById('ProductCount')?.classList.add('loading');
    document.getElementById('ProductCountDesktop')?.classList.add('loading');
    if (r) FacetFiltersForm.updateURLHash(e);
    FacetFiltersForm.getSections().forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${e}`;
      const cached = (entry) => entry.url === url;
      if (FacetFiltersForm.filterData.some(cached)) FacetFiltersForm.renderSectionFromCache(cached, t);
      else FacetFiltersForm.renderSectionFromFetch(url, t, version);
    });
  }
  static renderSectionFromFetch(e, t, version = FacetFiltersForm.requestVersion) {
    fetch(e, { signal: FacetFiltersForm.controller?.signal })
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return response.text();
      })
      .then((r) => {
        if (version !== FacetFiltersForm.requestVersion) return;
        const n = r;
        (FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html: n, url: e }]),
          FacetFiltersForm.renderFilters(n, t),
          FacetFiltersForm.renderSubcategoryFilters(n),
          FacetFiltersForm.renderProductGridContainer(n),
          FacetFiltersForm.renderProductCount(n);
      })
      .catch((error) => {
        if (error.name === 'AbortError' || version !== FacetFiltersForm.requestVersion) return;
        console.error('FacetFiltersForm: failed to refresh collection', error);
        document.querySelector('#ProductGridContainer .collection')?.classList.remove('loading');
        document.getElementById('ProductCount')?.classList.remove('loading');
        document.getElementById('ProductCountDesktop')?.classList.remove('loading');
      });
  }
  static renderSectionFromCache(e, t) {
    const r = FacetFiltersForm.filterData.find(e).html;
    FacetFiltersForm.renderFilters(r, t),
      FacetFiltersForm.renderSubcategoryFilters(r),
      FacetFiltersForm.renderProductGridContainer(r),
      FacetFiltersForm.renderProductCount(r);
  }
  static renderProductGridContainer(e) {
    const currentContainer = document.getElementById('ProductGridContainer');
    if (!currentContainer) return;

    const parsedDoc = new DOMParser().parseFromString(e, 'text/html');
    const nextContainer = parsedDoc.getElementById('ProductGridContainer');
    if (!nextContainer) {
      console.error('FacetFiltersForm: missing #ProductGridContainer in fetched section HTML.');
      return;
    }

    currentContainer.innerHTML = nextContainer.innerHTML;
    delete currentContainer.dataset.collectionRender;

    if (typeof window.initializeCollectionContent === 'function') {
      window.initializeCollectionContent(currentContainer);
    } else if (typeof window.initCollectionHeaderSwiper === 'function') {
      window.initCollectionHeaderSwiper();
    }

    document.dispatchEvent(new CustomEvent('initFastBuy'));
  }
  static renderProductCount(e) {
    const parsedDoc = new DOMParser().parseFromString(e, 'text/html');
    const newCount = parsedDoc.getElementById('ProductCount');
    const r = document.getElementById('ProductCount');
    if (!newCount || !r) return;

    (r.innerHTML = newCount.innerHTML), r.classList.remove('loading');

    FacetFiltersForm.updateShowProductsButton();
  }

  static updateShowProductsButton() {
    const productCountEl = document.getElementById('ProductCount');
    if (!productCountEl) return;

    const btnSpan = document.querySelector('#show-products-button span');
    if (!btnSpan) return;

    const text = productCountEl.textContent || '';

    const match = text.match(/\d+/);
    if (match) {
      btnSpan.textContent = '(' + match[0] + ')';
    } else {
      btnSpan.textContent = '';
    }
  }

  static syncMatchingCheckboxStates(sourceFormSelector, targetFormSelector) {
    const sourceInputs = document.querySelectorAll(`${sourceFormSelector} input[type="checkbox"]`);
    const targetInputs = document.querySelectorAll(`${targetFormSelector} input[type="checkbox"]`);

    sourceInputs.forEach((sourceInput) => {
      const value = sourceInput.value;
      const name = sourceInput.name;

      const matchingTarget = Array.from(targetInputs).find((el) => el.name === name && el.value === value);

      if (matchingTarget) {
        matchingTarget.disabled = sourceInput.disabled;
        matchingTarget.setAttribute('aria-disabled', sourceInput.getAttribute('aria-disabled'));
      }
    });
  }

  static renderFilters(html, event) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const allNewFilters = doc.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter');

    const clickedFilter = event ? event.target.closest('.js-filter') : null;
    const isClicked = (el) => clickedFilter && el.dataset.index === clickedFilter.dataset.index;

    const newFiltersOther = Array.from(allNewFilters).filter((el) => !isClicked(el));
    const newClickedFilter = Array.from(allNewFilters).find(isClicked);

    newFiltersOther.forEach((newEl) => {
      const currentEl = document.querySelector(`.js-filter[data-index="${newEl.dataset.index}"]`);
      if (currentEl) currentEl.innerHTML = newEl.innerHTML;
    });

    if (clickedFilter && newClickedFilter) {
      clickedFilter.innerHTML = newClickedFilter.innerHTML;
    }

    FacetFiltersForm.renderActiveFacets(doc);

    if (newClickedFilter && clickedFilter) {
      FacetFiltersForm.renderCounts(newClickedFilter, clickedFilter);
    }

    FacetFiltersForm.syncMatchingCheckboxStates('#FacetFiltersForm', 'subcategory-filters-form form');
    FacetFiltersForm.syncMatchingCheckboxStates('subcategory-filters-form form', '#FacetFiltersForm');
    FacetFiltersForm.renderActiveBadges();
    FacetFiltersForm.setupActiveFilterCount();
    FacetFiltersForm.hideEmptySubcategories();
  }
  static renderActiveFacets(e) {
    ['.active-facets-mobile', '.active-facets-desktop'].forEach((t) => {
      const r = e.querySelector(t);
      r && (document.querySelector(t).innerHTML = r.innerHTML);
    }),
      FacetFiltersForm.toggleActiveFacets(!1);
  }
  static renderCounts(e, t) {
    const r = t.querySelector('.facets__selected');
    e.querySelector('.facets__selected') &&
      r &&
      (t.querySelector('.facets__selected').outerHTML = e.querySelector('.facets__selected').outerHTML);
  }
  static updateURLHash(e) {
    history.pushState({ searchParams: e }, '', `${window.location.pathname}${e && '?'.concat(e)}`);
  }
  static getSections() {
    const el = document.getElementById('product-grid').dataset.id;
    // console.log('pobierany element:', el);
    return [{ section: document.getElementById('product-grid').dataset.id }];
  }
  static renderSubcategoryFilters(htmlString) {
    const newDoc = new DOMParser().parseFromString(htmlString, 'text/html');
    const newSubcategory = newDoc.querySelector('subcategory-filters-form');

    if (!newSubcategory) return;

    const current = document.querySelector('subcategory-filters-form');
    if (current) {
      current.innerHTML = newSubcategory.innerHTML;

      if (typeof current.connectedCallback === 'function') {
        current.connectedCallback();
      }
    }
  }

  static lastSubcategorySelected = null;
  // single choice - podkategorie
  static setupSingleChoiceSubcategory() {
    document.addEventListener('change', (e) => {
      const target = e.target;

      if (
        target.tagName !== 'INPUT' ||
        target.type !== 'checkbox' ||
        target.name !== 'filter.p.m.custom.filters_subcategories'
      ) {
        return;
      }

      const clickedFacet = target.closest('[data-index="podkategorie"]');
      if (!clickedFacet) return;

      const allPodkategorieCheckboxes = document.querySelectorAll(
        'input[type="checkbox"][name="filter.p.m.custom.filters_subcategories"]'
      );

      if (!target.checked && FacetFiltersForm.lastSubcategorySelected === target.value) {
        allPodkategorieCheckboxes.forEach((checkbox) => {
          checkbox.checked = FacetFiltersForm.isAllSubcategoryCheckbox(checkbox);
        });

        FacetFiltersForm.lastSubcategorySelected = null;
        FacetFiltersForm.toggleClearFiltersButton();
        return;
      }

      if (target.checked) {
        allPodkategorieCheckboxes.forEach((checkbox) => {
          checkbox.checked = checkbox.value === target.value;
        });
        FacetFiltersForm.lastSubcategorySelected = target.value;
        FacetFiltersForm.toggleClearFiltersButton();
      }
    });
  }
  //badge
  static renderActiveBadges() {
    const container = document.getElementById('active-filters-badges');
    if (!container) return;

    const checkboxes = document.querySelectorAll('input[type="checkbox"]:checked');
    const visibleCheckboxes = Array.from(checkboxes).filter(
      (checkbox) => checkbox.hasAttribute('data-label') && !FacetFiltersForm.isAllSubcategoryCheckbox(checkbox)
    );

    const uniqueCheckboxesMap = new Map();
    visibleCheckboxes.forEach((checkbox) => {
      const key = `${checkbox.name}::${checkbox.value}`;
      if (!uniqueCheckboxesMap.has(key)) {
        uniqueCheckboxesMap.set(key, checkbox);
      }
    });

    container.innerHTML = '';

    for (const checkbox of uniqueCheckboxesMap.values()) {
      const label = checkbox.getAttribute('data-label');
      const badge = document.createElement('div');
      badge.className = 'filter-badge';
      badge.dataset.value = checkbox.value;
      badge.dataset.name = checkbox.name;

      badge.innerHTML = `
        ${label}
        <button type="button" aria-label="Usuń filtr">
          <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
            <path d="M6.625 0.947266L0.625 6.94727" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M0.625 0.947266L6.625 6.94727" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      `;

      badge.querySelector('button').addEventListener('click', () => {
        dataLayerPromise({
          event: 'filters_interaction',
          section: 'listing_chips',
          element: 'chips',
          element_value: label,
          interaction_type: 'remove',
        });

        const allMatchingCheckboxes = document.querySelectorAll(
          `input[type="checkbox"][name="${checkbox.name}"][value="${checkbox.value}"]`
        );
        allMatchingCheckboxes.forEach((el) => {
          el.checked = false;
        });
        const groupCheckboxes = document.querySelectorAll(`input[type="checkbox"][name="${checkbox.name}"]`);
        const anyChecked = Array.from(groupCheckboxes).some((cb) => cb.checked);
        if (!anyChecked) {
          const allProductsCheckbox = Array.from(groupCheckboxes).find(
            (cb) => FacetFiltersForm.isAllSubcategoryCheckbox(cb)
          );
          if (allProductsCheckbox) {
            allProductsCheckbox.checked = true;
          }
        }

        const form = checkbox.closest('form');
        if (form) {
          const event = new Event('input', { bubbles: true });
          form.dispatchEvent(event);
        }
      });

      container.appendChild(badge);
    }
    FacetFiltersForm.toggleClearFiltersButton();
  }
  //filtry
  static setupActiveFilterCount() {
    const filterInputs = document.querySelectorAll('.facets__form .facets__item input');
    const activeFiltersCount = document.querySelector('.facets__form .facets__heading .active-filters-count');
    const filterDrawerButton = document.querySelector('#filter-drawer-button span');

    function updateActiveFilterCount() {
      const countedIndexes = new Set();
      let count = 0;

      filterInputs.forEach((input) => {
        const dataIndex = input.closest('.js-filter')?.getAttribute('data-index');
        const key = `${input.name}:${input.value}`;

        if (input.checked && !FacetFiltersForm.isAllSubcategoryCheckbox(input) && dataIndex && !countedIndexes.has(key)) {
          countedIndexes.add(key);
          count++;
        }
      });
      if (activeFiltersCount) {
        activeFiltersCount.innerText = count ? `(${count})` : '';
      }
      if (filterDrawerButton) {
        filterDrawerButton.innerText = count ? `(${count})` : '';
      }
    }

    filterInputs.forEach((input) => {
      input.addEventListener('change', updateActiveFilterCount);
    });

    updateActiveFilterCount();
  }

  static hideEmptySubcategories() {
    document.querySelectorAll('details[data-index="podkategorie"]').forEach((detailsEl) => {
      const ul = detailsEl.querySelector('ul.facets__list');
      if (ul && ul.querySelectorAll('li').length === 0) {
        detailsEl.style.display = 'none';
      } else {
        detailsEl.style.display = '';
      }
    });

    document.querySelectorAll('details[data-index="kategoria"]').forEach((detailsEl) => {
      const ul = detailsEl.querySelector('ul.facets__list');
      if (ul && ul.querySelectorAll('li').length === 0) {
        detailsEl.style.display = 'none';
      } else {
        detailsEl.style.display = '';
      }
    });
  }

  static clearAllFilters() {
    const subcategoryCheckboxes = document.querySelectorAll(
      'input[type="checkbox"][name="filter.p.m.custom.filters_subcategories"]'
    );

    const allFilters = document.querySelectorAll('input[type="checkbox"]');
    allFilters.forEach((checkbox) => {
      checkbox.checked = false;
    });

    const allProductsCheckbox = Array.from(subcategoryCheckboxes).find(
      (checkbox) => FacetFiltersForm.isAllSubcategoryCheckbox(checkbox)
    );

    if (allProductsCheckbox) {
      allProductsCheckbox.checked = true;
      FacetFiltersForm.lastSubcategorySelected = allProductsCheckbox.value;
    }

    const allForms = document.querySelectorAll('facet-filters-form form, subcategory-filters-form form');
    allForms.forEach((form) => {
      const event = new Event('input', { bubbles: true });
      form.dispatchEvent(event);
    });

    FacetFiltersForm.toggleClearFiltersButton();
  }

  static toggleClearFiltersButton() {
    const clearButton = document.getElementById('clear-filters-button');
    if (!clearButton) return;

    const checkboxes = document.querySelectorAll('input[type="checkbox"]:checked');
    const hasOtherThanAllProducts = Array.from(checkboxes).some((checkbox) => {
      return !FacetFiltersForm.isAllSubcategoryCheckbox(checkbox);
    });

    clearButton.style.display = hasOtherThanAllProducts ? 'block' : 'none';
  }

  onSubmitHandler(e) {
    e.preventDefault();

    const interactionType = e.target.checked ? 'select' : 'unselect';
    const inputType = e.target.getAttribute('data-type');
    const inputLabel = e.target.getAttribute('data-label');
    const inputName = e.target.name;

    let section = e.target.name;
    if (inputName.includes('filters_discover')) {
      section = 'Discover';
    } else if (inputName.includes('filters_needs')) {
      section = 'Needs';
    } else if (inputName.includes('product_line')) {
      section = 'Scent_line';
    } else if (inputName.includes('filters_subcategories')) {
      section = 'Subcategory';
    } else if (inputName.includes('filters_categories')) {
      section = 'category';
    }

    let element = '';
    const asideElement = e.target.closest('aside');
    if (asideElement && asideElement.classList.contains('mobile-active-drawer')) {
      element = 'modal_filters';
    } else if (asideElement) {
      element = 'sidebar_filters';
    } else {
      element = 'sub_category_tiles';
    }

    if (section === 'Subcategory' && element === 'modal_filters') {
      dataLayerPromise({
        event: 'filters_interaction',
        section: 'Sub_category_filter',
        element: 'text_link',
        element_value: inputLabel,
        interaction_type: interactionType,
      });
    } else if (section === 'Subcategory' && element === 'sub_category_tiles') {
      dataLayerPromise({
        event: 'filters_interaction',
        section: 'Sub_category_filter',
        element: 'photo_tile',
        element_value: inputLabel,
        interaction_type: 'click',
      });
    }
    dataLayerPromise({
      event: 'filters_interaction',
      section: section,
      element: element,
      element_value: inputLabel,
      interaction_type: interactionType,
    });

    const allForms = document.querySelectorAll('facet-filters-form form, subcategory-filters-form form');
    const paramMap = new Map();

    allForms.forEach((form) => {
      new FormData(form).forEach((value, key) => {
        const compositeKey = `${key}=${value}`;
        if (!paramMap.has(compositeKey)) {
          paramMap.set(compositeKey, [key, value]);
        }
      });
    });

    const urlParams = new URLSearchParams();
    for (const [_, [key, value]] of paramMap) {
      urlParams.append(key, value);
    }

    const queryString = urlParams.toString();

    FacetFiltersForm.renderPage(queryString, e);
    FacetFiltersForm.renderActiveBadges();
    FacetFiltersForm.toggleClearFiltersButton();
  }
  onActiveFilterClick(e) {
    e.preventDefault(), FacetFiltersForm.toggleActiveFacets();
    const t =
      -1 == e.currentTarget.href.indexOf('?') ? '' : e.currentTarget.href.slice(e.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(t);
  }

  static detailsStateMap = new Map();

  static trackDetailsToggleState() {
    const allDetails = document.querySelectorAll('.facets__disclosure');

    allDetails.forEach((detailsEl) => {
      const key = detailsEl.dataset.index;
      if (!key) return;

      const summary = detailsEl.querySelector('summary');
      summary.setAttribute('aria-expanded', detailsEl.open ? 'true' : 'false');

      detailsEl.addEventListener('toggle', () => {
        FacetFiltersForm.detailsStateMap.set(key, detailsEl.open);
      });
    });
  }

  static restoreDetailsToggleState() {
    const allDetails = document.querySelectorAll('.facets__disclosure');

    allDetails.forEach((detailsEl) => {
      let isOpen;

      if (FacetFiltersForm.detailsStateMap.has(detailsEl.dataset.index)) {
        isOpen = FacetFiltersForm.detailsStateMap.get(detailsEl.dataset.index);
      } else {
        isOpen = true;
      }

      detailsEl.open = isOpen;

      const summary = detailsEl.querySelector('summary');
      summary.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }
}
(FacetFiltersForm.filterData = []),
  (FacetFiltersForm.searchParamsInitial = window.location.search.slice(1)),
  (FacetFiltersForm.searchParamsPrev = window.location.search.slice(1)),
  customElements.define('facet-filters-form', FacetFiltersForm),
  FacetFiltersForm.setListeners();
class PriceRange extends HTMLElement {
  constructor() {
    super(),
      this.querySelectorAll('input').forEach((e) => e.addEventListener('change', this.onRangeChange.bind(this))),
      this.setMinAndMaxValues();
  }
  onRangeChange(e) {
    this.adjustToValidValues(e.currentTarget), this.setMinAndMaxValues();
  }
  setMinAndMaxValues() {
    const e = this.querySelectorAll('input'),
      t = e[0],
      r = e[1];
    r.value && t.setAttribute('max', r.value),
      t.value && r.setAttribute('min', t.value),
      '' === t.value && r.setAttribute('min', 0),
      '' === r.value && t.setAttribute('max', r.getAttribute('max'));
  }
  adjustToValidValues(e) {
    const t = Number(e.value),
      r = Number(e.getAttribute('min')),
      n = Number(e.getAttribute('max'));
    t < r && (e.value = r), t > n && (e.value = n);
  }
}
customElements.define('price-range', PriceRange);
class FacetRemove extends HTMLElement {
  constructor() {
    super(),
      this.querySelector('a').addEventListener('click', (e) => {
        e.preventDefault();
        (this.closest('facet-filters-form') || document.querySelector('facet-filters-form')).onActiveFilterClick(e);
      });
  }
}
customElements.define('facet-remove', FacetRemove);
const sortingElement = document.getElementById('SortBy');
function setSortingElementWidth(e) {
  const t = e.options[e.selectedIndex].text;
  e.parentElement.style.width = 30 + 7 * t.length + 'px';
}
sortingElement &&
  (setSortingElementWidth(sortingElement),
  sortingElement.addEventListener('change', function (e) {
    setSortingElementWidth(e.target);
  }));
const filterBtn = document.querySelector('.facets__heading');
filterBtn &&
  filterBtn.addEventListener('click', () => {
    filterBtn.parentElement.classList.add('expanded');
  });

class SubcategoryFiltersForm extends FacetFiltersForm {
  connectedCallback() {
    const form = this.querySelector('form');
    if (form) {
      form.addEventListener('input', this.debouncedOnSubmit.bind(this));
    }
    FacetFiltersForm.renderActiveBadges();
  }
}

customElements.define('subcategory-filters-form', SubcategoryFiltersForm);

document.addEventListener('DOMContentLoaded', () => {
  FacetFiltersForm.setupSingleChoiceSubcategory();
  FacetFiltersForm.renderActiveBadges();
  FacetFiltersForm.setupActiveFilterCount();
  FacetFiltersForm.hideEmptySubcategories();
  FacetFiltersForm.updateShowProductsButton();

  FacetFiltersForm.restoreDetailsToggleState();
  FacetFiltersForm.trackDetailsToggleState();

  const subcategoryCheckboxes = document.querySelectorAll(
    'input[type="checkbox"][name="filter.p.m.custom.filters_subcategories"]'
  );

  const anyChecked = Array.from(subcategoryCheckboxes).some((checkbox) => checkbox.checked);

  const allProductsCheckboxes = Array.from(subcategoryCheckboxes).filter(
    (checkbox) => FacetFiltersForm.isAllSubcategoryCheckbox(checkbox)
  );

  if (!anyChecked && allProductsCheckboxes.length > 0) {
    allProductsCheckboxes.forEach((checkbox) => {
      checkbox.checked = true;
    });

    FacetFiltersForm.lastSubcategorySelected = allProductsCheckboxes[0].value;

    const form = allProductsCheckboxes[0].closest('form');
    if (form) {
      const event = new Event('input', { bubbles: true });
      form.dispatchEvent(event);
    }
  } else {
    const checked = Array.from(subcategoryCheckboxes).find((cb) => cb.checked);
    if (checked) {
      FacetFiltersForm.lastSubcategorySelected = checked.value;
    }
  }

  const bodyElement = document.body;
  const button = document.getElementById('filter-drawer-button');
  const modal = document.querySelector('aside.facets-container');
  const filterBtn = document.querySelector('.facets__heading');
  const details = document.querySelectorAll('#FacetsWrapperDesktop details');
  const overlay = document.querySelector('.filters-overlay');
  const closeFilterModalButton = document.querySelector('.facets-close-modal');

  button.addEventListener('click', handleOpenFilterModal);

  closeFilterModalButton?.addEventListener('click', handleCloseFilterModal);
  overlay.addEventListener('click', handleCloseFilterModal);

  function handleOpenFilterModal() {
    modal.classList.add('mobile-active-drawer');
    overlay.classList.add('active');
    bodyElement.style.overflow = 'hidden';
    if (filterBtn) {
      filterBtn.parentElement.classList.add('expanded');
    }

    //details.forEach((el) => el.setAttribute('open', ''));
  }

  function handleCloseFilterModal() {
    modal.classList.remove('mobile-active-drawer');
    bodyElement.style.overflow = 'auto';
    overlay.classList.remove('active');
  }

  const clearFiltersButton = document.getElementById('clear-filters-button');
  if (clearFiltersButton) {
    clearFiltersButton.addEventListener('click', () => {
      FacetFiltersForm.clearAllFilters();
    });
  }

  const showProductsButton = document.getElementById('show-products-button');
  if (showProductsButton) {
    showProductsButton.addEventListener('click', handleCloseFilterModal);
  }
});
